module.exports = __webpack_public_path__ + "img/nin.c8ec5025.png";